export enum FileKind {
  ATTACHMENT = 'attachment',
  TRANSCRIPTION = 'transcription',
  RECORDING = 'recording',
  INTERNAL_RECORDING = 'internal_recording',
  COMPLIANCE_ASSET = 'compliance_asset',
  COMPLIANCE_ASSET_PHONE = 'compliance_asset.phone',
  LOGO_ASSET = 'logo_asset',
  DOCUMENT = 'document',
  FORM_TEMPLATE = 'form_template',
  USER_AVATAR_ASSET = 'user_avatar_asset',
  WORKFLOW_ASSET = 'workflow_asset',
}

export enum FileStatus {
  REQUESTED = 'requested',
  UPLOADED = 'uploaded',
  FAILED = 'failed',
  ARCHIVED = 'archived',
}

export interface SessionFile {
  fileId: string
  accountId: string
  roomId: string
  userId: string
  fileName: string
  fileSize: number
  contentType: string
  sessionId: null
  kind: FileKind
  metadata: string
  status: FileStatus
}

export interface TranscriptionMetadata {
  enhanced?: boolean
  recordingFileId?: string
  transcriptionType: string
}

export interface FileDownloadLocation {
  location: string
}

export interface FileInfo {
  fileId: string
  fileName: string
  fileSize: number
}
